import { UserService } from 'src/app/services/user.service';
import { Component, HostBinding, ChangeDetectorRef, HostListener } from '@angular/core';
import { PolicyService } from 'src/app/services/policy.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ContactUsComponent } from 'src/app/shared/dialogs/contact-us/contact-us.component';
import { UtilityService } from 'src/app/services/utility.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ClaimStats } from 'src/app/shared/models/claim.interface';
import { ClaimService } from 'src/app/services/claim.service';
import { TaggingService } from 'src/app/tags/tagging.service';
import { UserPermission } from 'src/app/shared/models/user-permission';
import { LoginService } from 'src/app/services/login.service';
import { AccountInfo } from 'src/app/shared/models/account-info.interface';
import { MatDialogConfig } from '@angular/material/dialog';
import { ContactUsPopupComponent } from '../contact-us-popup/contact-us-popup.component';
import { TooltipPosition } from '@angular/material/tooltip';
import { FormControl } from '@angular/forms';
import { DeliveryDefenseAgreementComponent } from '../../delivery-defense-agreement/delivery-defense-agreement.component';
import { DeliveryDefenseErrorComponent } from '../../delivery-defense-error/delivery-defense-error.component';
import { PolicyInfo } from 'src/app/shared/models/policy-info';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { SwitchPolicyEventService } from 'src/app/services/switch-policy-event.service';
import { PolicyEventService } from 'src/app/services/policy-event.service';
import { GuestLinkService } from 'src/app/services/guest-link.service';
import { forkJoin, Subscription } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { IPolicies } from 'src/app/shared/models/policies.interface';
import { BillingService } from 'src/app/services/billing.service';
import { PayorService } from 'src/app/services/payor.service';
import { AutoRefreshService } from 'src/app/services/auto-refresh-service';
import { of } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { ActivePolicy } from 'src/app/shared/models/smart-upload-shipment-file';
import { SmartUploadService } from 'src/app/services/smart-upload.service';
import { PolicyDateRangeService } from 'src/app/services/policy-date-range.service';

@Component({
  selector: 'upsc-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent {
  @HostBinding('class') public hostClass = 'navigation';
  private readonly smartUploadPolicyNoKey = 'smrtUploadPolicyNo';
  private readonly smartUploadFetchStatusKey = 'smrtUploadFetchStatus';

  //Display Scenario variables
  showBilling: boolean;
  showStats: boolean;
  showRLSMenuItems: boolean;
  showRLSNav: boolean; //whether to show navigation by role level security
  systemError;
  isPirateShip: boolean;
  showCRMLink: boolean = false;

  //Data/logic holding variables
  hasInsights: boolean;
  hasSmartUpload: boolean;
  hasDeliveryDefense: boolean;
  hasCEI: boolean;
  isDDClaimsFlow: boolean;
  claimStats: ClaimStats;
  isDDApplicable: boolean;
  isThreeContractNo: boolean;
  isCCPSelfServicePortal: boolean;
  messageCnt = "";
  isNickNameEdit: boolean = false;
  payorId: string = '';
  disableAddPolicy: boolean = false;
  isContract: boolean = false;
  salesforceTicketingSystemSSOURL: string = environment.links.salesforceTicketingSystemSSO;

  //User information
  isAdjuster: boolean;
  isUspsUser: boolean;
  isGuestClaim: boolean;
  isGuestUser: boolean;
  isCanadaUser: boolean;
  isUkUser: boolean;
  isUsaUser: boolean;
  isGermanyUser: boolean;
  isFranceUser: boolean;
  isItalyUser: boolean;
  isDDUser: boolean = false;
  isDDCGUser: boolean = false; //commerce guard
  userDetails: AccountInfo;
  Username: string;
  firstName: string;
  fName: string;
  isAdminRole: boolean;
  canManageUsers: boolean = false;
  loginName: string = '';
  isInternalUser: boolean;
  canChangePolicy: boolean;
  userPermission: UserPermission = new UserPermission();
  userRoleID: string = "";
  isAdminUser: boolean = false;
  app_role_id: number = 0;

  //CSS variables?
  popoverPosition$: any;
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  toolTipInfo: string = "Edit Nickname";

  //Policy related variables
  isConnectPolicy: boolean;
  policy: IPolicies;
  policyDetails: any;
  canTogglePolicy: boolean;
  policyType;
  policyInfoList: PolicyInfo[] = [];
  childPolicyList: string[] = [];

  //Form variables
  nickNameFormGroup: UntypedFormGroup;

  //Wallet variables
  billingWallet: boolean = false;
  showBillingWalletTab: boolean = false;
  dwDetails;
  upsBilled: boolean = false;
  canViewDigitalWallet: boolean = false;

  //Etc
  subscription: Subscription;

  //Bundled claims variables
  isBundledClaim: boolean = false;
  isSmartUploadEnabled: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private guestLinkService: GuestLinkService,
    private policyService: PolicyService,
    private utilityService: UtilityService,
    private claimService: ClaimService,
    private router: Router,
    private taggingService: TaggingService,
    private loginService: LoginService,
    public contactUsDialog: MatDialog,
    public dialog: MatDialog,
    public switchPolicyService: SwitchPolicyEventService,
    private policyEventService: PolicyEventService,
    private cdr: ChangeDetectorRef,
    private msalService: MsalService,
    private billingService: BillingService,
    private payorService: PayorService,
    private getStatsRefreshService: AutoRefreshService,
    private auth: AuthService,
    private smartUploadService: SmartUploadService,
    private policyDateRangeService: PolicyDateRangeService
  ) {
    this.popoverPosition$ = this.utilityService.popoverPositionWatch();
  }

  ngAfterViewChecked() {
    if (this.policyInfoList?.length >= 10) {
      this.disableAddPolicy = true;
    } else {
      this.disableAddPolicy = false;
    }
    this.cdr.detectChanges();
  }

  redirectToUrl(): void {
    window.open(this.salesforceTicketingSystemSSOURL, '_blank', 'noopener,noreferrer');
  }

  toggleExpiredPolicyPopover(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isExpiredPolicyPopoverOpen = !this.isExpiredPolicyPopoverOpen;
  }

  openExpiredPolicyLink(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isExpiredPolicyPopoverOpen = false;
    this.redirectToUrl();
  } 

  getSmartUploadPolicyInfo() {
    let activePolicy = new Object() as ActivePolicy;
    activePolicy.policyNo = this.policyDetails?.policyNumber;
    if (!activePolicy.policyNo) {
      this.isSmartUploadEnabled = false;
      return;
    }
    try {
      this.smartUploadService.getSmartUploadPolicyInfo(activePolicy).subscribe(
        (response) => {
          if (response !== null && response !== undefined) {
            sessionStorage.setItem('smrtUploadPolicyDetails', JSON.stringify(response));
            sessionStorage.setItem(this.smartUploadPolicyNoKey, activePolicy.policyNo);
            sessionStorage.setItem(this.smartUploadFetchStatusKey, 'success');
            this.isSmartUploadEnabled = this.policyDateRangeService.isCurrentDateWithinPolicyRange();
          } else {
            // Handle null or undefined response - indicates inactive policy
            sessionStorage.removeItem('smrtUploadPolicyDetails');
            sessionStorage.setItem(this.smartUploadPolicyNoKey, activePolicy.policyNo);
            sessionStorage.setItem(this.smartUploadFetchStatusKey, 'failed');
            this.isSmartUploadEnabled = false;
          }
        },
        (error) => {
          console.error('Error fetching policy info:', error);
          sessionStorage.removeItem('smrtUploadPolicyDetails');
          sessionStorage.setItem(this.smartUploadPolicyNoKey, activePolicy.policyNo);
          sessionStorage.setItem(this.smartUploadFetchStatusKey, 'failed');
          this.isSmartUploadEnabled = false;
        }
      );
    } catch {
      sessionStorage.removeItem('smrtUploadPolicyDetails');
      sessionStorage.setItem(this.smartUploadPolicyNoKey, activePolicy.policyNo);
      sessionStorage.setItem(this.smartUploadFetchStatusKey, 'failed');
       this.isSmartUploadEnabled = false;
    }
  }

  ngOnInit() {
    this.isUspsUser = this.userService.isUSPSUser();
    this.isAdjuster = this.userService.isUserAdjuster();
    this.isInternalUser = this.userService.isInternalUser();
    this.isGuestClaim = this.userService.isGuestClaim();
    this.isGuestUser = this.userService.isGuestUser();
    this.showBilling = this.policyService.isGWPolicy();
    this.hasInsights = this.policyService.hasInsights();
    this.hasDeliveryDefense = this.policyService.hasDeliveryDefense();
    this.showRLSMenuItems = !this.userService.isInternalUser() || !!this.loginService.getPolicyDetails()?.policyNumber;
    this.isDDApplicable = !this.policyService.isThreeHyphenContractNo() && !this.policyService.isTwoHyphenContractNo();
    this.isThreeContractNo = this.policyService.isThreeHyphenContractNo();
    this.policy = this.loginService.getPolicyDetails();
    this.canManageUsers = this.userService.getUserPermissions()?.isUserManagement && !this.policyService.isTUPSSContractNumber();
    this.isCanadaUser = this.userService.isCanadaUser();
    this.isUkUser = this.userService.isUkUser();
    this.isUsaUser = this.userService.isUsaUser();
    this.isGermanyUser = this.userService.isGermanyUser();
    this.isFranceUser = this.userService.isFranceUser();
    this.isItalyUser = this.userService.isItalyUser();
    this.isDDUser = this.userService.isDeliveryDefenseUser();
    this.isDDClaimsFlow = this.userService.isDDClaimsFlow();
    this.isDDCGUser = this.userService.isDDCommerceGuardUser();
    this.isAdminRole = this.userService.isAdminRole();
    this.isConnectPolicy = this.policyService.isConnectPolicy();
    this.userRoleID = this.userService.getUserInfo().userRoleID;
    this.dwDetails = this.loginService.getDWDetails();
    this.determineUPSBilled();
    this.app_role_id = this.userService.getUserInfo().app_role_id;
    if (this.isInternalUser && (this.app_role_id === 7 || this.app_role_id === 9)) {
      this.canViewDigitalWallet = true;
    }
    this.policyType = this.policyService.determinePolicyType(this.policy);

    this.userDetails = this.userService.getUserInfo();
    this.Username = sessionStorage.getItem('userid');
    this.determineCRMLink();

    if (this.userDetails.userAppRoleID == '1' || this.userDetails.app_role_id == 1) {
      this.isAdminUser = true;
    }

    // Bundled claims check
    this.isBundledClaim = this.userService.isBundledClaimUser();

    //CCP Self Service portal check
    if (!this.policy?.sspIndicator) {
      this.guestLinkService.ccpSSPCheck$.subscribe((data) => {
        let ccp_SSP_Details = JSON.parse(sessionStorage.getItem('ccpUniquePartnerName'));
        if (ccp_SSP_Details && ccp_SSP_Details.ccp_selfService_Check == true) {
          this.isCCPSelfServicePortal = true;
        }
      });
    } else {
      this.isCCPSelfServicePortal = true;
    }

    if (this.dwDetails?.walletID) {
      this.showBillingWalletTab = true;
    }
    this.isPirateShip = this.policyService.isPirateShipFlow();

    if (this.userDetails && ((this.userDetails.userAppRoleID == '1') || (this.policyService.isToggleExpandedFor(this.userDetails.userAppRoleID)))) {
      this.subscription = this.policyEventService.nameData$.subscribe((data) => {
        this.getUserPolicyDetails();
      });
    } else if (this.userDetails && (this.userDetails.userAppRoleID > '1') || (this.userDetails.internalUser)) {
      this.subscription = this.policyEventService.nameData$.subscribe((data) => {
        this.getUserPolicyDetails();
      });
    }

    let data = this.loginService.getPolicyDetails();
    if (data != undefined && data != null) {
      if ((this.loginService.getPolicyDetails().policyNumber) && (!this.isDDUser) && !this.isPirateShip) {
       this.loadClaimStats();

       // Listen for refresh events
        this.getStatsRefreshService.refreshRequired$
        .subscribe(() => {
            this.loadClaimStats();
            console.log('Received refresh event, reloading claim stats');
          });
      }
    }

    this.nickNameFormGroup = this.formBuilder.group({
      nickNameFormControl: ['', [Validators.required, Validators.minLength(6)]]
    });


    this.userPermission = this.userService.getUserPermissions();

    this.showRLSNav = !this.isInternalUser || this.policyService.hasPolicyDetails();
    this.canChangePolicy = this.isInternalUser;

    this.hasSmartUpload = this.policyService.hasSmartUpload() || this.isConnectPolicy;

    if (this.userDetails) {
      //US Users and internal Admins have access to Consumer Elected Insurance
      if (!this.isGuestClaim && this.isUsaUser && (!this.isInternalUser || this.userDetails.app_role_id === 1)) {
        this.hasCEI = true

      }
      else {
        this.hasCEI = false;
      }

      try {
        this.fName = this.userDetails.contactName.substring(0, 1);
        this.loginName = this.userDetails.contactName;
      }
      catch {
        this.fName = 'I';
        this.loginName = 'Internal User';
      }
    } else {
      this.loginService.removeLocalStorage(this.Username, this.userDetails?.objectUID).subscribe(result => { });
      this.router.navigate(['/login']);
      window.location.reload();
    }

    this.policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    if (this.policyDetails) { // this checks to see if DD agreement has already been accepted
      // Call startDeliveryDefense to reroute to DD
    }
    
    //allow user to toggle policy if they have the permission to manage users or if the policy is in the expanded toggle policies list and user role is claim manager or filer
    this.canTogglePolicy = this.userService.hasAdministratorRole() || this.policyService.isToggleExpandedFor(this.userDetails.userAppRoleID);
    this.isContractOrPolicyType();
    this.payorId = this.payorService.getPayorId();

    const currentPolicyNo = this.policyDetails?.policyNumber;
    const cachedPolicyNo = sessionStorage.getItem(this.smartUploadPolicyNoKey);
    const cachedFetchStatus = sessionStorage.getItem(this.smartUploadFetchStatusKey);
    const cachedSmartUploadDetails = sessionStorage.getItem('smrtUploadPolicyDetails');
    if (currentPolicyNo && cachedPolicyNo === currentPolicyNo) {
      if (cachedFetchStatus === 'success' && cachedSmartUploadDetails) {
        this.isSmartUploadEnabled = this.policyDateRangeService.isCurrentDateWithinPolicyRange();
        return;
      }

      if (cachedFetchStatus === 'failed') {
        this.isSmartUploadEnabled = false;
        return;
      }
    }

    this.getSmartUploadPolicyInfo();
  }


  loadClaimStats() {
    this.claimService.getClaimStats(this.loginService.getPolicyDetails().policyNumber, '').subscribe(
      data => {
        this.claimStats = data;
        this.showStats = this.claimStats.claimsWithNewMessagesCnt > 0;
        this.messageCnt = "You have " + this.claimStats?.claimsWithNewMessagesCnt + " new messages!";
      }
    );
  }


  isContractOrPolicyType() {
    if (this.policy?.policyTypeIndicator === "Contract") {
      this.isContract = true;
    }
  }

  getPolicyDetails(userId: any, groupId: any, shipperNumber: any) {

    let request = {
      userId: userId,
      groupId: groupId !== null ? groupId : 0,
      shipperNumber: shipperNumber !== null ? shipperNumber.toString() : '',
    };
    this.policyInfoList.splice(0, this.policyInfoList.length);
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    this.policyService.getUserPolicyDetails(request).subscribe(
      response => {
        this.policyInfoList = [];
        this.childPolicyList = [];

        let policyInfo = new PolicyInfo();
        policyInfo.policyNumber = response.data.parentPolicy;
        policyInfo.productType = response.data.parentSubPolicyType !== null ? response.data.parentSubPolicyType : '';
        policyInfo.nickName = response.data.nickname;
        policyInfo.policyHoldersName = response.data.policyHoldersName;
        if (policyDetails != undefined && policyDetails != null) {
          if (policyDetails.policyNumber === response.data.parentPolicy) {
            policyInfo.isActive = true;
          }
        } else {
          policyInfo.isActive = false;
        }
        var parentPolicyExist = this.policyInfoList.find(x => x.policyNumber === response.data.parentPolicy);
        if (!parentPolicyExist) {
          this.policyInfoList.push(policyInfo);
        }

        if (response.data.childPolicies !== undefined && response.data.childPolicies !== null && response.data.childPolicies.length > 0) {
          response.data.childPolicies?.forEach(item => {
            policyInfo = new PolicyInfo();
            policyInfo.policyNumber = item.childPolicyNumber;
            policyInfo.productType = item.childSubPolicyType !== null ? item.childSubPolicyType : '';
            policyInfo.nickName = item.nickname;
            policyInfo.policyHoldersName = item.childHoldersName;
            if (policyDetails.policyNumber === item.childPolicyNumber) {
              policyInfo.isActive = true;
            }
            else {
              policyInfo.isActive = false;
            }
            var isPolicyExist = this.policyInfoList.find(x => x.policyNumber === item.childPolicyNumber);
            if (!isPolicyExist) {
              this.policyInfoList.push(policyInfo);
              this.childPolicyList.push(item.childPolicyNumber);
            }
            sessionStorage.setItem("PolicyCount", this.policyInfoList.length.toString());
            sessionStorage.setItem("UserPolicyDetails", JSON.stringify(this.policyInfoList));
            sessionStorage.setItem("childPoliciesEA", JSON.stringify(this.childPolicyList));
          });
        } else {
          sessionStorage.setItem("childPoliciesEA", JSON.stringify(this.childPolicyList));
        }
        sessionStorage.setItem("PolicyCount", this.policyInfoList.length.toString());
        sessionStorage.setItem("UserPolicyDetails", JSON.stringify(this.policyInfoList));
      },
      error => {
        console.log(error);
      }
    );
  }

  getChildPolicies() {
    var isPolicyList = sessionStorage.getItem("childPoliciesEA");
    if (isPolicyList !== null) {
      this.childPolicyList.splice(0, this.policyInfoList.length);
      this.childPolicyList = JSON.parse(sessionStorage.getItem("childPoliciesEA"));
      return this.childPolicyList;
    }
  }

  getUserPolicyDetails() {
    var isPolicyList = sessionStorage.getItem("UserPolicyDetails");
    if (this.isInternalUser) {
      this.policyInfoList.push({
        policyNumber: this.policy.policyNumber,
        productType: this.policy.subPolicyType,
        nickName: '',
        policyHoldersName: this.policy.insured,
        isActive: true,
      });
    }
    else if (isPolicyList === null || isPolicyList === undefined || isPolicyList === '0') {
      this.policyInfoList.splice(0, this.policyInfoList.length);
      let userId = this.userService.getUserInfo().userId;
      let groupID = this.userService.getUserInfo().groupID;
      let shipperNumber = this.userService.getUserInfo().groupID;
      this.getPolicyDetails(userId, groupID, shipperNumber);
    }
    else {
      this.policyInfoList.splice(0, this.policyInfoList.length);
      this.policyInfoList = JSON.parse(sessionStorage.getItem("UserPolicyDetails"));
    }
  }

  currentNickName = ''
  editNickName($event: any, nickName: string) {
    $event.stopPropagation();
    this.currentNickName = nickName;
    this.isNickNameEdit = true;
  }

  updateNickName($event: any, item: any) {
    $event.stopPropagation();
    let request = {
      userID: Number(this.userDetails.userId),
      policyNumber: item.policyNumber,
      policyNickname: item.nickName
    };
    this.policyService.updatePolicyNickname(request).subscribe(
      data => {
        if (data) {
          this.isNickNameEdit = false;
          sessionStorage.setItem("UserPolicyDetails", "0");
          this.getUserPolicyDetails();
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  closeNickName($event: any) {
    $event.stopPropagation();
    this.isNickNameEdit = false;
  }

  togglePolicy(policy: any) {
    this.switchPolicyService.togglePolicy(policy.policyNumber, this.userService.hasClaimsManagerRole() ? 3 : this.userService.hasClaimsFilerRole() ? 4 : Number(this.userDetails.userRoleID));
  }

  isPageInit: boolean = false;
  ngAfterContentInit() {
    this.isPageInit = true;
    try {
      this.fName = this.userDetails.contactName.substring(0, 1);
      this.loginName = this.userDetails.contactName;
    }
    catch {
      this.fName = 'I';
      this.loginName = 'Internal User';
    }
  }

  resetPolicy() {
    sessionStorage.removeItem('policyDetails');
    sessionStorage.removeItem('ccpUniquePartnerName');
    sessionStorage.removeItem('dwDetails');
    sessionStorage.removeItem('payorCount');
    sessionStorage.removeItem('payorId');
    sessionStorage.removeItem('shipperAccountDetails');
    sessionStorage.removeItem('partnerShipmentDetails');
    sessionStorage.removeItem('portalBannerDismissed');
    sessionStorage.removeItem('portalBanner');
    this.router.navigate(['internal']);
  }

  isCollapsed: boolean = true;
  isExpiredPolicyPopoverOpen: boolean = false;
  dialogRef: any;
  contactusPopover: boolean = false;
  contactusPopoverCanada: boolean = false;
  @HostListener('document:click', ['$event'])
  onDocumentClickCloseExpiredPolicy(): void {
    this.isExpiredPolicyPopoverOpen = false;
  }

  // Function to check if the click happened outside the popup
  private isClickOutsidePopup(event: MouseEvent): boolean {
    const popupElement = document.getElementById('popupDiv');
    return popupElement && !popupElement.contains(event.target as Node);
  }


  contactUs() {
    let contactusPopover = 'false';
    let contactusPopoverCanada = 'false';
    if ((this.isCanadaUser && this.isGuestUser) == true) {
      contactusPopover = 'true';
      contactusPopoverCanada = 'false';
    }
    else if (this.isCanadaUser == true) {
      contactusPopoverCanada = 'true';
      contactusPopover = 'false';
    }
    else {
      contactusPopover = 'true';
      contactusPopoverCanada = 'false';
    }

    sessionStorage.setItem("contactusPopover", contactusPopover);
    sessionStorage.setItem("contactusPopoverCanada", contactusPopoverCanada);

    let config = new MatDialogConfig();
    config.autoFocus = false;
    config.closeOnNavigation = true;
    config.width = this.isUsaUser ? '250px' : '500px';
    config.position = { right: '50px', top: '100px' }
    config.data = {
      contactusPopover: contactusPopover,
      contactusPopoverCanada: contactusPopoverCanada,
      name: 'Test Contact Us'
    }

    this.dialogRef = this.dialog
      .open(ContactUsPopupComponent, config)
      .afterClosed().subscribe(result => {

      });
  }


  contactUs1() {
    if ((this.isCanadaUser && this.isGuestUser) == true) {
      console.log('contactusPopover');
    }
    else if (this.isCanadaUser == true) {
      console.log('contactusPopoverCanada');
    }
    else {
      console.log('contactusPopover');
    }
  }

  logout(event) {
    let terminateSmartUpload = of({})
    let smartUploadSession = JSON.parse(sessionStorage.getItem('smartUploadSession'));
    if(smartUploadSession) {
      terminateSmartUpload =this.policyService.getSmartUploadUrl(smartUploadSession);
    }

    let terminateHVCM = of({});
    let hvcmSession = JSON.parse(sessionStorage.getItem('HVCMSession'));
    if(hvcmSession) {
      terminateHVCM = this.userService.getHVCMUrl(hvcmSession);
    }

    forkJoin([terminateSmartUpload, terminateHVCM]).subscribe(
      res => this.cleanUpAndRedirect(),
      err => this.cleanUpAndRedirect()
    );
  }

  cleanUpAndRedirect() {
    this.taggingService.link({ link_name: 'log_out' });
    if (this.isInternalUser) { //internal users
      sessionStorage.clear()
      localStorage.clear();
      this.auth.logout({ logoutParams: { returnTo: environment.roleLevelSecurity.signout }});
    } else {
      this.loginService.removeLocalStorage(this.Username, this.userDetails.objectUID).subscribe(result => { });
      let locale = null;
      this.auth.logout({ logoutParams: { returnTo: environment.auth0.defaultLogoutUrl }});
    }
  }

  addPolicy() {
    this.router.navigate(['/newpolicy']);
  }

  ngOnDestroy() {
    sessionStorage.removeItem('retainState');
    sessionStorage.removeItem('isPostBack');
    sessionStorage.removeItem('pageId');
    sessionStorage.removeItem('isadvanced');
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openContactUsDialog(): void {
    this.taggingService.link({
      link_name: 'contact_us_header_tab'
    });
    const dialogRef = this.contactUsDialog.open(ContactUsComponent);

    dialogRef.afterClosed().subscribe(result => {
    });
  }

   navigate2SmartUpload(){
    this.router.navigate(['/smartupload']);
  }

  startSmartUpload(event) {
    let smartUploadURL = environment.smartUpload.url;

    this.policyService.getSmartUploadUrl({
      policyno: this.loginService.getPolicyDetails().policyNumber,
      username: this.userService.getUserInfo().firstName
    }).subscribe(
      data => {
        if (data.url && data.url != '') {
          smartUploadURL = data.url;
        }
        window.open(smartUploadURL);
      },
      error => {
        window.open(smartUploadURL);
      }
    );
  }

  validateDeliveryDefense(event) {
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    if (policyDetails && policyDetails.ref1 == 'DD' && policyDetails.ref2) { // this checks to see if DD agreement has already been accepted
      // Call startDeliveryDefense to reroute to DD
      this.startDeliveryDefense(event);
    }
    else if (policyDetails && policyDetails.ref1 == 'DD API' && policyDetails.ref2_1) {
      // These are "DD API" users, still re-route to DD, but call a different API to get the redirection link.
      this.startDDAPIUser();
    }
    else { // this means ref2 was null or non-existent, which signals for us to display the pop-up
      const dialogRef = this.dialog.open(DeliveryDefenseAgreementComponent);
    }
  }

  // call startDeliveryDefense only if they've accepted terms and conditions- which is indicated by the presence of the ref2 field in policyDetails
  startDeliveryDefense(event) {
    this.policyService.getDeliveryDefenseUrl({
      emailId: this.userService.getUserInfo().emailAddress,
      contractNumber: JSON.parse(sessionStorage.getItem('policyDetails')).ref2

    }).subscribe(
      res => {
        if (res.data.url && res.data.url != '') {
          window.open(res.data.url);
        } else {
          let matDialog2 = this.dialog.open(DeliveryDefenseErrorComponent);
        }
      },
      error => {
        let matDialog = this.dialog.closeAll();
        let matDialog2 = this.dialog.open(DeliveryDefenseErrorComponent);
      }
    );
  }

  startDDAPIUser() {
    this.policyService.getDDAPIUrl({
      emailId: this.userService.getUserInfo().emailAddress,
      partnerId: JSON.parse(sessionStorage.getItem('policyDetails')).ref2_1
    }).subscribe(
      res => {
        if (res.data.url && res.data.url != '') {
          window.open(res.data.url);
        } else {
          let matDialog2 = this.dialog.open(DeliveryDefenseErrorComponent);
        }
      },
      error => {
        let matDialog = this.dialog.closeAll();
        let matDialog2 = this.dialog.open(DeliveryDefenseErrorComponent);
      }
    )
  }

  startDeliveryDefense1(event) {
    let deliveryDefenseURL = environment.deliveryDefense.url;

    this.policyService.getDeliveryDefenseUrl({
      emailId: this.userService.getUserInfo().emailAddress,
    }).subscribe(
      res => {
        if (res.data.url && res.data.url != '') {
          deliveryDefenseURL = res.data.url;
        }
        window.open(deliveryDefenseURL);
      },
      error => {
        window.open(deliveryDefenseURL);
      }
    );
  }

  gotoMessages(event: any) {
    this.router.navigate(['claims', 'message-list']);
  }

  tagging(type) {
    if (type == 'dashboard') {
      this.taggingService.link({ link_name: 'dashboard_header_tab' });
    } else if (type == 'policies') {
      this.taggingService.link({ link_name: 'policies_header_tab' });
    } else if (type == 'claims') {
      this.taggingService.link({ link_name: 'claims_header_tab' });
    } else if (type == 'billing') {
      this.taggingService.link({ link_name: 'billing_header_tab' });
    }
  }

  consumerElectedInsurance() {

    this.userService.getConsumerElectedInsurance().subscribe({
      next: (res) => {
        // console.log('Response:', res);
        window.open(res as string, '_blank');
      },
      error: (err) => {
        console.error("Error fetching consumer elected insurance", err);
      }
    });
  }

  determineUPSBilled() {
    if (this.dwDetails && this.dwDetails?.billingType && this.dwDetails?.billingType?.trim()?.toLowerCase() == 'ups') {
      this.upsBilled = true;
    } else {
      this.upsBilled = false;
    }
  }

  navigateToDW() {
    this.systemError = false;
    let _payorID = '';
    let billingSystem = '';
    try {
      if ((this.policyType.toLowerCase() == 'traditional_cargo')) {
        billingSystem = 'gw';
        _payorID = '';
      } else {
        billingSystem = 'billiant';
        _payorID = this.payorId;
      }
    } catch {

    }

    let _navigatingSystemRole = 'admin';
    if (this.canViewDigitalWallet) {
      _navigatingSystemRole = 'viewer';
    }

    let request = {
      action: "accesswallet", //Hardcoded
      navigatingSystem: "onl", //Hardcoded
      navigatingSystemRole: _navigatingSystemRole, //Hardcoded (assume admin)
      productSystem: "gw", //Hardcoded (not coming from cbp/dd)
      productSystemIdentifier1: this.policyDetails?.policyNumber,
      productSystemIdentifier1Name: "policyno",
      productSystemIdentifier2: this.policyDetails?.accountNumber,
      productSystemIdentifier2Name: "pcAccountNumber",
      productType: "iscomplete", //Hardcoded (unless we want to change later based on databricks policytype value)
      country: "us", //Harcoded (wallet is US only)
      locale: "en", //Hardcoded (wallet is US only)
      userIdentifier1Name: "createdbyuserid",
      userIdentifier1: this.userDetails?.userId?.toString(),
      displayName: this.userDetails?.contactName, //QUESTION: Use user's name or policy holder's name?
      userEmail: this.userDetails?.emailAddress, //QUESTION: Do we want to use user's info here or policy's email?
      objectUID: this.userDetails?.objectUID,
      callBackURL: "https://online.upscapital.com", //Hardcoded (we don't need this field, remove if possible)
      returnURL: "https://online.upscapital.com", //Hardcoded (we don't need this field, remove if possible)
      billingsystem: billingSystem,
      payorID: _payorID
    };
    this.billingService.DWstartSession(request).subscribe(
      data => {
        if (data?.data?.url) {
          window.open(data?.data?.url, '_blank');
        } else {
          this.systemError = true;
        }
      }, error => {
        this.systemError = true;
      }
    );
  }

  determineCRMLink() {
    if (this.isInternalUser) {
      this.showCRMLink = false;
      return;
    }
    this.showCRMLink = true;
  }
}
